// extracted by mini-css-extract-plugin
module.exports = {"productsTableContainer":"ProductTable_productsTableContainer_asXaQ","noresultsTableHeight":"ProductTable_noresultsTableHeight_3Y57M","emptyItems":"ProductTable_emptyItems_70Eok"};